import {
    SORT_TYPES_CINEMA_SCHEDULE_SUCCEEDED,
    SORT_TYPES_CINEMA_SCHEDULE_FAILED,
    REQUEST_MOVIES_BY_CINEMA_SUCCEEDED,
    REQUEST_MOVIES_BY_CINEMA_FAILED,
    REQUEST_MOVIES_BY_CINEMA_ID_SUCCEEDED,
    REQUEST_MOVIES_BY_CINEMA_ID_FAILED,
    REQUEST_SCHEDULE_MOVIES_ALL,
    SCHEDULE_MOVIES_ALL_SUCCEEDED,
    SCHEDULE_MOVIES_ALL_FAILED
} from '../actions/types';

const initialState = {
    errors: {},
    scheduleAllMovies: [],
    movies: []
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SORT_TYPES_CINEMA_SCHEDULE_SUCCEEDED:
            return {
                ...state,
                ...action.payload
            };

        case SORT_TYPES_CINEMA_SCHEDULE_FAILED:
            return {
                errors: {
                    ...action.payload
                }
            };
        case REQUEST_MOVIES_BY_CINEMA_SUCCEEDED:
            return {
                ...state,
                movies: action.payload,
            };

        case REQUEST_MOVIES_BY_CINEMA_FAILED:
            return {
                errors: {
                    ...action.payload
                }
            };

        case REQUEST_MOVIES_BY_CINEMA_ID_SUCCEEDED:
            return {
                ...state,
                movies: action.payload,
            };

        case REQUEST_MOVIES_BY_CINEMA_ID_FAILED:
            return {
                errors: {
                    ...action.payload
                }
            };

        case REQUEST_SCHEDULE_MOVIES_ALL:
            return {
                errors: {
                    ...action.payload
                }
            };
        case SCHEDULE_MOVIES_ALL_SUCCEEDED:
            return {
                ...state,
                scheduleAllMovies: action.payload,
            };

        case SCHEDULE_MOVIES_ALL_FAILED:
            return {
                errors: {
                    ...action.payload
                }
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/SHARED/reducers/schedule.reducer.js